import { Link } from 'react-router-dom';

function EventCard({ event, onDelete, isAuthenticated, isAdmin, wishId, onToggleWish }) {
  const formatDate = (dateString) => {
    if (!dateString) return 'No date';
    return new Date(dateString).toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="event-card">
      <Link to={`/events/${event.id}`} className="event-card__link">
        {event.url_image && (
          <img
            src={event.url_image}
            alt={event.title}
            className="event-card-image"
          />
        )}
        <h3>{event.title}</h3>
        <p className="event-date">{formatDate(event.date)}</p>
        <p className="event-category">{event.category}</p>
        <p className="event-description">
          {event.description?.length > 100
            ? `${event.description.substring(0, 100)}...`
            : event.description}
        </p>
      </Link>
      {(isAdmin || (isAuthenticated && onToggleWish)) && (
        <div className="event-actions">
          {isAdmin && (
            <>
              <Link to={`/events/${event.id}/edit`} className="btn btn-secondary">Edit</Link>
              <button onClick={() => onDelete(event.id, event.title)} className="btn btn-danger">Delete</button>
            </>
          )}
          {isAuthenticated && onToggleWish && (
            <button
              onClick={() => onToggleWish(event.id)}
              className={`wish-heart-btn ${wishId ? 'wish-heart-btn--filled' : ''}`}
              aria-label={wishId ? 'Remove from wishes' : 'Add to wishes'}
            >
              {wishId ? '♥' : '♡'}
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default EventCard;
